<template>
  <div>
    <Drawer class="customizeMyDesignDrawer_box" :title="customizeMyDesignTitle" v-model="customizeMyDesignModal" width="1000"
      :mask-closable="false" :closable="true" @on-visible-change="customizeMyDesignChange" :before-close="handleBeforeClose">
      <!--步骤条-->
      <template v-if="operationType === 'designedProducts' && designOperationType === 'add'">
        <div class="stepBar_box">
          <Steps :current="progressStatus">
            <Step v-for="item in progressList" :title="item.title" :content="item.content" icon="md-checkmark-circle"></Step>
          </Steps>
        </div>
        <Divider style="margin: 10px 0 12px 0;"/>
        <!--商品选择-->
        <Card :bordered="false" dis-hover v-if="progressStatus === 0">
          <template #title>
            <span class="red-dot title_box">{{ $t('key1000685') }}</span>
          </template>
          <h2 class="font-size-13 color-666 mb12">{{ $t('key1000715') }}</h2>
          <div class="flex flex-wrap align-items-center wid100P">
            <vueTreeSelect
              style="width:320px; margin-right: 15px;"
              v-model="pageParams.ymsProductCategoryId"
              :clearable="true"
              :searchable="true"
              :openOnFocus="true"
              :closeOnSelect="true"
              :noResultsText="$t('key1000102')"
              :noOptionsText="$t('key1000375')"
              :placeholder="$t('key1000713')"
              :normalizer="normalizer"
              :options="ymsProductCategoryList">
              <template #option-label="{ node, labelClassName }">
                <label
                  :class="labelClassName"
                  :title="node.label">
                  {{ node.label }}
                </label>
              </template>
            </vueTreeSelect>
            <Input style="width:180px; margin-right: 15px;" v-model.trim="pageParams.cnName" :placeholder="$t('key1000380')"/>
            <Input style="width:180px; margin-right: 15px;" v-model.trim="pageParams.ymsSpus" :placeholder="$t('key1000714')"/>
            <Button class="mr12" type="primary" @click="search">{{ $t('key1000011') }}</Button>
            <Button @click="reset">{{ $t('key1000109') }}</Button>
          </div>
          <!--列表区域-->
          <div class="table-box mt14">
            <Table
              ref="tbableDom"
              highlight-row
              border
              max-height="480"
              :loading="tableLoading"
              :columns="tableColumns"
              :data="tableData">
              <template #selectCustomizedProducts="{row, index}">
                <Radio
                  :true-value="1"
                  :false-value="0"
                  v-model="row.selectCustomizedProducts"
                  @on-change="(val)=>selectCustomizedProductsChange(val,row,index)">
                </Radio>
              </template>
            </Table>
          </div>
          <!--分页区域-->
          <Page
            :transfer="true"
            v-if="!tableLoading"
            :total="total"
            style="text-align: right; margin: 20px 0;"
            @on-change="changePage"
            show-total
            :page-size="pageParams.pageSize"
            show-elevator
            :current="pageParams.pageNum"
            show-sizer
            @on-page-size-change="changePageSize"
            placement="top"
            :page-size-opts="pageArray">
          </Page>
        </Card>
      </template>
      <template v-if="progressStatus === 1">
        <!--商品定制信息配置-->
        <Card :bordered="false" dis-hover v-if="customizedInfoConfigTalg">
          <template #title>
            <span class="red-dot title_box">{{ $t('key1000716') }}</span>
          </template>
          <div class="flex align-items-center justify-content-between mb12">
            <h2 class="font-size-13 color-666">{{ $t('key1000717') }}</h2>
            <Button type="primary" @click="addCustomizedContentBtn" :disabled="addCustomizedContentTalg">{{ $t('key1000718') }}</Button>
          </div>
          <Table
            :disabled-hover="true"
            :highlight-row="false"
            border
            max-height="530"
            :loading="tableLoading"
            :columns="customizedContentColumns"
            :data="customizedContentTableData">
            <!--定制部位-->
            <template #customizedParts="{row, index}">
              <Select v-model.trim="customizedContentTableData[index].customizedParts" transfer style="width:150px;" filterable
                @on-change="(value)=>customizedPartsChange(value)">
                <Option v-for="(k, index) in customizedPartsList" :disabled="k.disabled" :key="index" :value="k.ymsProductCategoryPositionId">
                  {{ k.parts }}
                </Option>
              </Select>
            </template>
            <!--素材图-->
            <template #materialImage="{row, index}">
              <span v-if="!customizedContentTableData[index].customizedParts" class="font-size-12 color-666">{{ $t('key1000719') }}</span>
              <template v-else>
                <div class="imgagesList_box" v-viewer="viewerOptions" v-if="customizedContentTableData[index].materialImageList">
                  <div class="imgagesList_box_item" v-for="(path,idx) in customizedContentTableData[index].materialImageList" :key="idx">
                    <div class="img_content">
                      <span class="clickOnCrop_box">{{ $t('key1000720') }}</span>
                      <img class="img-styles" :src="setImgPath(path, null, null, null, false)" @error="setErrorImg($event)" alt=""/>
                    </div>
                    <div class="flex align-items-center justify-content-center cursor mt8">
                      <span class="font-size-12 themeColor mr4" style="position: relative; top: 1px;" @click="deleteImgBtn(index,idx, 'materialImage')">{{ $t('key1000512') }}</span>
                      <Icon type="ios-trash-outline" size="18" @click="deleteImgBtn(index,idx, 'materialImage')"/>
                    </div>
                  </div>
                  <Upload
                    v-if="customizedContentTableData[index].materialImageList.length < 1"
                    name="files"
                    :headers="headObj"
                    :show-upload-list="false"
                    :on-success="(response, file, fileList) => uploadImageSuccess(response, file, fileList, index, 'materialImage')"
                    :on-error="uploadFilesError"
                    :before-upload="(file) => handleImgbeforeUpload(file)"
                    :multiple="false"
                    :action="uploadFilesUrl"
                    type="drag"
                    style="display: inline-block; width:75px;">
                    <div class="upload-box">
                      <i class="iconfont upload-icon">&#xe63e;</i>
                      <p>{{ $t('key1000465') }}</p>
                    </div>
                  </Upload>
                </div>
              </template>
            </template>
            <!--成品预览图-->
            <template #finishedProductPreviewImage="{row, index}">
              <span v-if="!customizedContentTableData[index].customizedParts" class="font-size-12 color-666">{{ $t('key1000719') }}</span>
              <template v-else>
                <div class="imgagesList_box" v-viewer="viewerOptions" v-if="customizedContentTableData[index].finishedProductPreviewImageList">
                  <div class="imgagesList_box_item" v-for="(path,idx) in customizedContentTableData[index].finishedProductPreviewImageList" :key="idx">
                    <div class="img_content">
                      <span class="clickOnCrop_box">{{ $t('key1000720') }}</span>
                      <img class="img-styles" :src="setImgPath(path, null, null, null, false)" @error="setErrorImg($event)" alt=""/>
                    </div>
                    <div class="flex align-items-center justify-content-center cursor mt8">
                      <span class="font-size-12 themeColor mr4" style="position: relative; top: 1px;" @click="deleteImgBtn(index,idx, 'finishedProductPreviewImage')">{{ $t('key1000512') }}</span>
                      <Icon type="ios-trash-outline" size="18" @click="deleteImgBtn(index,idx, 'finishedProductPreviewImage')"/>
                    </div>
                  </div>
                  <Upload
                    v-if="customizedContentTableData[index].finishedProductPreviewImageList.length < 2"
                    name="files"
                    :headers="headObj"
                    :show-upload-list="false"
                    :on-success="(response, file, fileList) => uploadImageSuccess(response, file, fileList, index, 'finishedProductPreviewImage')"
                    :on-error="uploadFilesError"
                    :before-upload="(file) => handleImgbeforeUpload(file)"
                    multiple
                    :action="uploadFilesUrl"
                    type="drag"
                    style="display: inline-block; width:75px;">
                    <div class="upload-box">
                      <i class="iconfont upload-icon">&#xe63e;</i>
                      <p>{{ $t('key1000465') }}</p>
                    </div>
                  </Upload>
                </div>
              </template>
            </template>
          </Table>
        </Card>
        <template v-else>
          <!--商品规格-->
          <Card :bordered="false" dis-hover>
            <template #title>
              <span class="red-dot title_box">{{ $t('key1000721') }}</span>
            </template>
            <h2 class="font-size-13 color-666 mb12">{{ $t('key1000722') }}</h2>
            <div class="flex flex-wrap mb8 align-items-center" v-for="(item, index) in selectSpecificationsList">
              <span class="specificationsName">{{ item.placeholderName + '：' }}</span>
              <Tag color="#FD5425" v-for="(ele,idx) in item.specificationsList" :checkable="ele.checkable"
                :class="ele.disabled ? 'setCursor' : ''"
                :checked="ele.checked" @on-change="(checked) => selectSpecifications(checked, index, idx)">
                {{ ele.value }}
              </Tag>
            </div>
          </Card>
          <!--商品定制信息配置-->
          <Card :bordered="false" dis-hover>
            <template #title>
              <h2 class="title_box">{{ $t('key1000716') }}</h2>
            </template>
            <h2 class="font-size-13 color-666 mb12">{{ $t('key1000723') }}</h2>
            <Button type="primary" ghost style="margin-bottom: 12px;" @click="batchConfigurationBtn">{{ $t('key1000724') }}</Button>
            <div class="flex flex-wrap align-items-center wid100P">
              <Select v-for="item in selectSpecificationsList" v-model.trim="item.value" transfer
                filterable class="mr12 mb12" :placeholder="item.placeholderName" style="width: 150px">
                <Option v-for="ele in item.selectData" :value="ele.specificationsValueId">{{ ele.value }}</Option>
              </Select>
              <Button class="ml12 mr12" style="margin-bottom: 12px;" type="primary" @click="search">{{ $t('key1000011') }}</Button>
              <Button @click="reset" style="margin-bottom: 12px;">{{ $t('key1000109') }}</Button>
            </div>
            <Table
              ref="tableDom"
              :highlight-row="false"
              border
              max-height="400"
              :loading="tableLoading"
              :columns="specificationsColumns"
              @on-selection-change="getSelectSpecificationsValue"
              :data="specificationsTableData">
            </Table>
          </Card>
        </template>
      </template>
      <div class="drawer_footer">
        <Button class="mr15" type="primary" @click="customizeMyDesignBtn">{{ $t('key1000111') }}</Button>
        <Button class="mr15" v-if="progressStatus > 0 && ((operationType === 'customDesign' && customizedInfoConfigTalg)
      || operationType === 'designedProducts' && designOperationType !== 'edit'
      || operationType === 'designedProducts' && designOperationType === 'edit' && customizedInfoConfigTalg)" @click="previousStepBtn">{{ $t('key1000725') }}</Button>
        <Button @click="cancelBtn">{{ $t('key1000112') }}</Button>
      </div>
    </Drawer>
    <!--设计成功提示弹窗-->
    <Modal v-model="designSuccessPromptModal" :title="designSuccessPromptTitle" width="600" :transfer="false" :mask-closable="false">
      <div v-if="operationType === 'customDesign'">
        <span>{{ $t('key1000726') }}</span>
        <span class="distributorThemeColor">{{ ymsSpuList.join('、') }}</span>
        <span>{{ $t('key1000727') }}</span>
        <span class="distributorThemeColor">{{ $t('key1000728') }}</span>
        <span>{{ $t('key1000729') }}</span>
      </div>
      <div v-else>
        <span>{{ $t('key1000730') }}</span>
        <span class="distributorThemeColor">{{ ymsSpuList.join('、') }}</span>
        <span>{{ $t('key1000727') }}</span>
        <span class="distributorThemeColor">{{ $t('key1000728') }}</span>
        <span>{{ $t('key1000731') }}</span>
      </div>
      <template #footer>
        <template v-if="operationType === 'customDesign'">
          <Button class="mr15" @click="designSuccessPromptModal = false">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="designSuccessPromptBtn('toBack')">{{ $t('key1000111') }}</Button>
        </template>
        <template v-else>
          <Button type="primary" @click="designSuccessPromptBtn('update')">{{ $t('key1000732') }}</Button>
        </template>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {commonLocalStorage, commonSessionStorage, getCloudTreeData, isJSON, pageJump} from "@/utils/common";
import {MAPPINGLANGNAME, MAPPINGLANGVALUE} from "@/utils/enum";
import vueTreeSelect from "@riophae/vue-treeselect";

export default {
  name: 'customizeMyDesignDrawer',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      uploadFilesUrl: api.erpCommon_uploadFiles + '?basePath=yms-distributor-service&action="uploadimage"',
      customizeMyDesignTitle: '',
      customizeMyDesignModal: false,
      progressStatus: 0,
      progressList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000685'), content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000686')},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000687'), content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000688')}
      ],
      operationType: null,
      selectSpecificationsList: [],
      specificationsColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 320,
          key: 'productInfo',
          align: 'left',
          render(h, params) {
            let ymsSpu = params.row.ymsSpu;
            let productName = params.row.productName;
            let imgPath = params.row.imgPath;
            let list = [
              v.tableImg(h, params, 'primaryImage', imgPath),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    AlinkShow: false,
                    linkName: productName,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_2'
                  }
                }),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689')),
                  h('Alink', {
                    props: {
                      AlinkShow: false,
                      linkName: ymsSpu,
                      textAlign: 'left',
                      AlinkClass: 'distributorThemeColor'
                    }
                  })
                ]),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          minWidth: 170,
          key: 'skuInfo',
          align: 'left',
          render: (h, params) => {
            let ymsSku = params.row.ymsSku;
            let specifications = params.row.specifications;
            return h('div', [
              h('p', {class: 'mt2 mb2'}, ymsSku),
              h('p', {class: 'mt2 mb2 color-green'}, specifications)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          minWidth: 150,
          renderHeader: (h, {column}) => {
            return h('div', [
              h('span', {class: 'red-dot'}, column.title),
              h('Checkbox', {
                props: {value: v.theSameTalg},
                class: 'ml10',
                on: {
                  'on-change': (checked) => {
                    v.theSameTalg = checked;
                    if (checked) {
                      const firstHasConfig = v.specificationsTableData.find(
                        item => item.configureCustomizedInfo && Object.keys(item.configureCustomizedInfo).length > 0
                      );
                      if (firstHasConfig) {
                        const sameConfig = JSON.parse(JSON.stringify(firstHasConfig.configureCustomizedInfo));
                        // 更新三个数据源
                        ['specificationsTableData', 'cacheData', 'originalSpecificationsTableData'].forEach(key => {
                          v[key] = v[key].map(item => ({
                            ...item,
                            configureCustomizedInfo: {
                              partBos: sameConfig.partBos,
                              ymsProductGoodsId: item.ymsProductGoodsId,
                              ymsSku: item.ymsSku
                            }
                          }));
                        });
                      }
                    }
                  }
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000690'))
            ]);
          },
          render(h, {row, index}) {
            const hasConfig = row.configureCustomizedInfo && Object.keys(row.configureCustomizedInfo).length > 0;
            return h('div', {class: 'flex align-items-center justify-content-center'}, [
              h('Icon', {
                props: {
                  type: hasConfig ? 'ios-checkmark-circle-outline' : 'ios-alert-outline',
                  size: 20,
                  color: hasConfig ? '#0FE316' : '#FF9B06'
                },
                class: 'mr8'
              }),
              h('span', {
                class: 'cursor themeColor',
                on: {
                  click() {
                    v.configureCustomizedContentData('single', row, index);
                  }
                }
              }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000691'))
            ]);
          }
        }
      ], // 商品规格列表
      specificationsTableData: [],
      originalSpecificationsTableData: [],
      cacheData: [],
      customizedContentColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000692'),
          key: 'customizedParts',
          minWidth: 150,
          align: 'left',
          renderHeader: (h, params) => {
            return h('span', {class: 'red-dot'}, params.column.title);
          },
          slot: 'customizedParts'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000693'),
          key: 'materialImage',
          minWidth: 300,
          align: 'left',
          renderHeader: (h, params) => {
            return h('span', {class: 'red-dot'}, params.column.title);
          },
          slot: 'materialImage'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000694'),
          renderHeader: (h, params) => {
            return h('span', {class: 'red-dot'}, params.column.title);
          },
          key: 'finishedProductPreviewImage',
          minWidth: 300,
          align: 'left',
          slot: 'finishedProductPreviewImage'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'center',
          width: 100,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                isShowMoreBtn: false,
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.customizedContentTableData.length > 1,
                    clickFn: () => {
                      v.deleteCustomizedContentBtn(params.index);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ], //定制部位列表
      customizedContentTableData: [],
      customizedPartsList: [],
      customizedInfoConfigTalg: false, // 定制信息配置标识
      selectGoodsList: [],
      currentIndex: null,
      batchConfigTalg: false,
      detailsData: {},
      designSuccessPromptModal: false,
      ymsSpuList: [],
      designOperationType: null,
      pageParamsStatus: false,
      pageParams: {
        ymsProductCategoryId: null,
        cnName: '',
        ymsSpus: '',
        pageNum: 1,
        pageSize: 15
      },
      ymsProductCategoryList: [],
      tableColumns: [
        {
          title: '',
          key: 'selectCustomizedProducts',
          align: 'center',
          width: 50,
          renderHeader: (h) => {
            return h('span', '');
          },
          slot: 'selectCustomizedProducts'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 320,
          key: 'productInfo',
          align: 'left',
          render(h, params) {
            let ymsSpu = params.row.ymsSpu;
            let name = params.row.name;
            let productName = '';
            if (name) {
              if (isJSON(name)) {
                let obj = JSON.parse(name);
                productName = obj[v.languagesVal];
              } else {
                productName = name;
              }
            }
            let imagePath = params.row.imagePath;
            let list = [
              v.tableImg(h, params, 'imagePath', imagePath),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                h('Alink', {
                  props: {
                    AlinkShow: false,
                    linkName: productName,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_2'
                  }
                }),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689')),
                  h('Alink', {
                    props: {
                      AlinkShow: false,
                      linkName: ymsSpu,
                      textAlign: 'left',
                      AlinkClass: 'distributorThemeColor'
                    }
                  })
                ]),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000695'),
          key: 'skuNumber',
          minWidth: 120,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000696'),
          key: 'supplierInventory',
          minWidth: 160,
          align: 'left',
          render(h, params) {
            let ymsReportInventories = params.row.ymsReportInventories || [];
            let sum = ymsReportInventories.reduce((pre, cur) => {
              return pre + cur.inventoryNumber;
            }, 0);
            return h('span', sum);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697'),
          renderHeader(h) {
            return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697') + '(' + v.currencyState + ')');
          },
          key: 'suggestPrice',
          minWidth: 160,
          align: 'left',
          render(h, params) {
            let maxSuggestPrice = params.row.maxSuggestPrice;
            let minSuggestPrice = params.row.minSuggestPrice;
            let price = '';
            if (maxSuggestPrice && minSuggestPrice) {
              price = minSuggestPrice + ' ~ ' + maxSuggestPrice;
            } else {
              price = '0 ~ 0';
            }
            if (maxSuggestPrice && !minSuggestPrice) {
              price = maxSuggestPrice;
            }
            if (!maxSuggestPrice && minSuggestPrice) {
              price = minSuggestPrice;
            }
            return h('span', price);
          }
        }
      ],
      tableData: [],
      total: 0,
      designSuccessPromptTitle: '',
      productGoodsList: [],
      customizedProductId: null,
      theSameTalg: false,
    };
  },
  computed: {
    addCustomizedContentTalg() {
      return this.customizedPartsList.every(item => item.disabled === true) ||
        this.customizedContentTableData.length >= this.customizedPartsList.length;
    },
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initCustomizeMyDesignData(operationType, type, details) {
      this.operationType = operationType;
      this.designOperationType = type;
      this.originalSpecificationsTableData = [];
      this.customizedProductId = null;
      this.cacheData = [];
      const handleData = (productGoodsList, selectGoodsList) => {
        return new Promise((resolve) => {
          const ymsProductGoodsIds = productGoodsList.map(item => item.ymsProductGoodsId).filter(id => id);
          this.handleSpecificationsTableData(ymsProductGoodsIds, productGoodsList, selectGoodsList).then((newData) => {
            this.specificationsTableData = newData;
            this.originalSpecificationsTableData = JSON.parse(JSON.stringify(newData));
            this.cacheData = JSON.parse(JSON.stringify(newData));
            this.progressStatus = 1;
            resolve(newData);
          });
        });
      };
      switch (operationType) {
        // 定制设计
        case 'customDesign':
          let obj = JSON.parse(JSON.stringify(details));
          this.specificationsTableData = [];
          this.customizeMyDesignTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000698');
          let productGoodsList = obj.productGoodsList || [];
          handleData(productGoodsList);
          break;
        // 设计的商品
        case 'designedProducts':
          // 新增设计
          if (type === 'add') {
            this.customizeMyDesignTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000699');
            let query = {
              isSupportCustomization: 1
            };
            let obj = commonSessionStorage.getItem('erpConfig');
            let ymsSiteId = obj ? obj.ymsSite ? obj.ymsSite.ymsSiteId : null : null;
            getCloudTreeData(api.post_ymsProductCategory_api_queryAll, null, null, ymsSiteId, query).then((data) => {
              this.ymsProductCategoryList = data;
            });
            this.progressStatus = 0;
            this.search();
          }
          // 编辑定制信息
          else {
            this.customizeMyDesignTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000700');
            this.specificationsTableData = [];
            let obj = JSON.parse(JSON.stringify(details));
            this.customizedProductId = obj.ymsProductId;
            let productGoodsList = obj.ymsProductGoods || [];
            let originalYmsProductGoods = obj.originalYmsProductGoods || [];
            let results = [];
            handleData(originalYmsProductGoods, productGoodsList).then((newData) => {
              newData.map(item => {
                productGoodsList.map(ele => {
                  if (item.supplierProductGoodsId === ele.supplierOriginalProductGoodsId) {
                    results.push(item.specificationsValueId);
                  }
                });
              });
              if (results.length > 0) {
                const data = this.originalSpecificationsTableData || [];
                let newList = data.filter(item => {
                  return results.includes(item.specificationsValueId);
                });
                newList.map((item) => {
                  this.originalSpecificationsTableData.map((ele) => {
                    if (item.ymsProductGoodsId === ele.ymsProductGoodsId) {
                      item.configureCustomizedInfo = JSON.parse(JSON.stringify(ele.configureCustomizedInfo));
                    }
                  });
                });
                this.specificationsTableData = newList;
                this.cacheData = JSON.parse(JSON.stringify(newList));
                this.$forceUpdate();
              }
            });
          }
          break;
      }
      this.customizeMyDesignModal = true;
    },
    // 处理列表数据
    handleSpecificationsTableData(ymsProductGoodsIds, productGoodsList, selectGoodsList = []) {
      let groupedAll = {};
      let selectGroupedAll = {};
      this.selectSpecificationsList = [];
      return new Promise((resolve) => {
        this.getProductInfoByIds(ymsProductGoodsIds, productGoodsList).then((newList) => {
          newList.map((item, index) => {
            if (!item.configureCustomizedInfo) {
              item.configureCustomizedInfo = {};
            }
            let specificationsList = [];
            if (item._productInfo) {
              let skuImgPath = item._productInfo.primaryImage;
              let spuImgPath = item._productInfo._spuInfo.primaryImage;
              item.imgPath = skuImgPath ? skuImgPath : spuImgPath;
              item.productName = item._productInfo._spuInfo.name;
              item.ymsSpu = item._productInfo._spuInfo.ymsSpu;
              item.ymsProductGoodsPositions = item._productInfo.ymsProductGoodsPositions || []; // 商品定制部位下拉数据
              let productGoodsSpecificationList = item._productInfo.productGoodsSpecificationList || [];
              let productGoodsSpecifications = productGoodsSpecificationList.filter(spec =>
                !spec.ymsProductGoodsSpecificationImages || spec.ymsProductGoodsSpecificationImages.length === 0);
              if (productGoodsSpecifications.length > 0) {
                specificationsList = productGoodsSpecifications.map((item) => {
                  return item.value;
                });
              }
              item.specifications = specificationsList.join(' • ');

              // 处理属性值、属性名多语种映射
              productGoodsSpecifications.map((k) => {
                k.name = k.multilingual ? k.multilingual[MAPPINGLANGNAME[this.languagesVal]] : k.name;
                k.value = k.multilingual ? k.multilingual[MAPPINGLANGVALUE[this.languagesVal]] : k.value;
              });
              let specificationsValue = [];
              productGoodsSpecifications.forEach(spec => {
                specificationsValue.push(spec.name + ':' + spec.value);
                if (!groupedAll[spec.name]) {
                  groupedAll[spec.name] = [];
                }
                if (!groupedAll[spec.name].some(s => s.value === spec.value)) {
                  groupedAll[spec.name].push({
                    ...spec,
                    specificationsValueId: spec.name + ':' + spec.value
                  });
                }
              });
              item.specificationsValueId = specificationsValue.join('_');
              // 处理定制信息
              if (selectGoodsList.length > 0) {
                selectGoodsList.map((ele) => {
                  if (item.supplierProductGoodsId === ele.supplierOriginalProductGoodsId) {
                    let list = [];
                    let ymsProductGoodsSpecifications = ele.ymsProductGoodsSpecifications || [];
                    ymsProductGoodsSpecifications.map((k) => {
                      let ymsProductGoodsSpecificationImagesList = k.ymsProductGoodsSpecificationImages || [];
                      ymsProductGoodsSpecificationImagesList.map((j, idx) => {
                        list.push({
                          parts: j.parts,
                          imageType: j.imageType,
                          md5: j.md5,
                          path: j.path,
                          sortNo: idx
                        });
                      });
                    });
                    let arr1 = ymsProductGoodsSpecifications.filter(spec =>
                      !spec.ymsProductGoodsSpecificationImages || spec.ymsProductGoodsSpecificationImages.length === 0);
                    if (arr1.length > 0) {
                      arr1.forEach(spec => {
                        if (!selectGroupedAll[spec.name]) {
                          selectGroupedAll[spec.name] = [];
                        }
                        if (!selectGroupedAll[spec.name].some(s => s.value === spec.value)) {
                          selectGroupedAll[spec.name].push({
                            ...spec,
                            specificationsValueId: spec.name + ':' + spec.value
                          });
                        }
                      });
                    }
                    let partBosList = this.handerGrouping(list, function (item) {
                      return [item.parts];
                    }, 'parts', 'imageBos');
                    if (partBosList.length > 0) {
                      item.configureCustomizedInfo = {
                        partBos: partBosList,
                        ymsProductGoodsId: item.ymsProductGoodsId,
                        ymsSku: item.ymsSku,
                      };
                    }
                    item.newYmsProductGoodsId = ele.ymsProductGoodsId;
                  }
                });
              }
            }
          });
          Object.keys(groupedAll).forEach(key => {
            let newList = groupedAll[key];
            if (Object.keys(selectGroupedAll).length > 0) {
              let arr = selectGroupedAll[key] || [];
              newList.map((item) => {
                item.checked = false;
                item.checkable = newList.length !== 1;
                item.disabled = newList.length === 1;
                arr.map((ele) => {
                  if (item.specificationsValueId === ele.specificationsValueId) {
                    item.checked = true;
                    item.checkable = arr.length !== 1;
                    item.disabled = arr.length === 1;
                  }
                });
              });
              this.selectSpecificationsList.push({
                placeholderName: key,
                specificationsList: newList,
                value: null,
                selectData: arr
              });
            } else {
              newList.map((item) => {
                item.checked = true;
                item.checkable = newList.length !== 1;
                item.disabled = newList.length === 1;
              });
              this.selectSpecificationsList.push({
                placeholderName: key,
                specificationsList: newList,
                value: null,
                selectData: newList
              });
            }
          });
          resolve(newList);
        });
      });
    },
    // 搜索
    search() {
      if (this.progressStatus === 0) {
        this.productGoodsList = [];
        this.pageParams.pageNum = 1;
        this.pageParamsStatus = true;
      } else {
        this.updateTableData('select');
      }
    },
    // 更新列表数据
    updateTableData(type) {
      const results = [];
      let primaryAttributeList = [];
      let attributeList = [];
      switch (type) {
        // 手动选择规格
        case 'change':
          this.selectSpecificationsList.forEach((group, index) => {
            (group.specificationsList || []).forEach(it => {
              if (it.checked) {
                if (index === 0) {
                  primaryAttributeList.push(`${it.name}:${it.value}`);
                } else {
                  attributeList.push(`${it.name}:${it.value}`);
                }
              }
            });
          });
          primaryAttributeList.map((k) => {
            if (attributeList.length > 0) {
              attributeList.map((j) => {
                let val = `${k}_${j}`;
                results.push(val);
              });
            } else {
              results.push(k);
            }
          });
          const data = this.originalSpecificationsTableData || [];
          let newList = data.filter(item => {
            return results.includes(item.specificationsValueId);
          });
          newList.map((item) => {
            this.originalSpecificationsTableData.map((ele) => {
              if (item.ymsProductGoodsId === ele.ymsProductGoodsId) {
                item.configureCustomizedInfo = JSON.parse(JSON.stringify(ele.configureCustomizedInfo));
              }
            });
          });
          this.specificationsTableData = newList;
          this.cacheData = JSON.parse(JSON.stringify(newList));
          this.$forceUpdate();
          break;

        // 下拉框选择规格值
        case 'select':
          let valueList = [];
          this.selectSpecificationsList.forEach(item => {
            if (item.value) {
              valueList.push(item.value);
            }
          });
          const targetId = valueList.length > 0 ? valueList.join('_') : '';
          if (targetId) {
            const data = this.cacheData || [];
            let newList = data.filter(item => {
              return item.specificationsValueId.indexOf(targetId) !== -1;
            });
            newList.map((item) => {
              this.originalSpecificationsTableData.map((ele) => {
                if (item.ymsProductGoodsId === ele.ymsProductGoodsId) {
                  item.configureCustomizedInfo = JSON.parse(JSON.stringify(ele.configureCustomizedInfo));
                }
              });
            });
            this.specificationsTableData = newList;
          }
          break;
      }
    },
    // 重置筛选
    reset() {
      let v = this;
      if (v.progressStatus === 0) {
        v.pageParams = {
          ymsProductCategoryId: null,
          cnName: '',
          ymsSpus: '',
          pageNum: 1,
          pageSize: 15
        };
        v.search();
      } else {
        v.selectSpecificationsList.map((item) => {
          item.value = null;
        });
        v.specificationsTableData = [];
        setTimeout(() => {
          v.specificationsTableData = JSON.parse(JSON.stringify(v.cacheData));
        }, 800);
      }
    },
    // 选择规格
    selectSpecifications(checked, listIndex, itemIndex) {
      const specificationsList = this.selectSpecificationsList[listIndex].specificationsList;
      this.$set(specificationsList[itemIndex], 'checked', checked);
      const totalTrue = specificationsList.reduce((acc, it) => acc + (it.checked ? 1 : 0), 0);
      let isOnlyOne = false;
      specificationsList.forEach((it) => {
        isOnlyOne = (totalTrue === 1) && it.checked;
        this.$set(it, 'checkable', !isOnlyOne);
        this.$set(it, 'disabled', isOnlyOne);
      });
      let newList = specificationsList.filter((item) => item.checked);
      newList.map((item) => {
        item.specificationsValueId = item.name + ':' + item.value;
      });
      this.selectSpecificationsList[listIndex].selectData = newList;
      this.reset();
      this.updateTableData('change');
      this.$forceUpdate();
    },
    // 重置数据
    resetData() {
      this.productGoodsList = [];
      this.specificationsTableData = [];
      this.originalSpecificationsTableData = [];
      this.cacheData = [];
      this.selectSpecificationsList = [];
      this.customizedInfoConfigTalg = false;
      this.customizedContentTableData = [];
      this.customizedPartsList = [];
      this.selectGoodsList = [];
      this.batchConfigTalg = false;
      this.detailsData = {};
      this.theSameTalg = false;
    },
    // 关闭之前的二次弹窗提示确认
    handleBeforeClose(value) {
      let v = this;
      return new Promise((resolve, reject) => {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000701'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000702'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            if (value === 'cancel') {
              v.resetData();
            }
            resolve();
          },
          onCancel: () => {
            reject();
          }
        });
      });
    },
    // 取消按钮
    cancelBtn() {
      this.handleBeforeClose().then(() => {
        this.resetData();
        this.customizeMyDesignModal = false;
      });
    },
    // 上一步
    previousStepBtn() {
      const setData = () => {
        this.customizedInfoConfigTalg = false;
        this.customizedContentTableData = [];
        this.customizedPartsList = [];
        this.selectGoodsList = [];
        this.batchConfigTalg = false;
        this.detailsData = {};
        this.progressStatus = 1;
      };
      this.handleBeforeClose().then(() => {
        if (this.operationType === 'customDesign') {
          setData();
        } else {
          if (this.designOperationType === 'add') {
            if (this.customizedInfoConfigTalg) {
              setData();
            } else {
              this.productGoodsList = [];
              this.specificationsTableData = [];
              this.originalSpecificationsTableData = [];
              this.cacheData = [];
              this.selectSpecificationsList = [];
              this.progressStatus = 0;
              this.reset();
            }
          } else {
            setData();
          }
        }
        this.selectGoodsList = [];
      });
    },
    // 勾选列表数据
    getSelectSpecificationsValue(data) {
      this.selectGoodsList = data;
    },
    // 确定按钮
    customizeMyDesignBtn() {
      let v = this;
      v.ymsSpuList = [];
      switch (v.operationType) {
        // 定制设计
        case 'customDesign':
          if (v.customizedInfoConfigTalg) {
            v.saveCustomizedPartsData();
          } else {
            handleData();
          }
          break;
        // 设计的商品
        case 'designedProducts':
          if (v.progressStatus === 0) {
            let productGoodsList = v.productGoodsList || [];
            if (productGoodsList.length > 0) {
              const ymsProductGoodsIds = productGoodsList.map(item => item.ymsProductGoodsId).filter(id => id);
              v.handleSpecificationsTableData(ymsProductGoodsIds, productGoodsList).then((newData) => {
                v.specificationsTableData = newData;
                v.originalSpecificationsTableData = JSON.parse(JSON.stringify(newData));
                v.cacheData = JSON.parse(JSON.stringify(newData));
              });
              v.progressStatus = 1;
            } else {
              v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000703'));
              return false;
            }
          } else {
            if (v.customizedInfoConfigTalg) {
              v.saveCustomizedPartsData();
            } else {
              if (v.designOperationType === 'add') {
                handleData();
              } else {
                if (v.cacheData.length > 0) {
                  let customizedProductInfoTalg = v.cacheData.every((item) => Object.keys(item.configureCustomizedInfo).length > 0);
                  if (!customizedProductInfoTalg) {
                    v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000704'));
                    return false;
                  }
                  let list = [];
                  v.cacheData.map((item) => {
                    list.push({
                      partBos: item.configureCustomizedInfo.partBos,
                      customizedProductId: v.customizedProductId,
                      supplierOriginalProductGoodsId: item.supplierProductGoodsId || null,
                      ymsProductGoodsId: item.newYmsProductGoodsId || null
                    });
                  });
                  v.axios.post(api.post_ymsDistributorProductInfo_updateCustomizationProducts, list,
                    {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
                    if (response.data.code === 0) {
                      v.customizeMyDesignModal = false;
                      v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
                      v.$emit('updateData', true);
                    }
                  });
                }
              }
            }
          }
          break;
      }

      function handleData() {
        if (v.cacheData.length > 0) {
          let customizedProductInfoTalg = v.cacheData.every((item) => Object.keys(item.configureCustomizedInfo).length > 0);
          if (!customizedProductInfoTalg) {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000704'));
            return false;
          }
          let list = v.cacheData.map((item) => {
            return item.configureCustomizedInfo;
          });
          v.axios.post(api.post_ymsDistributorProductInfo_createCustomizationGoods, list,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas || [];
              if (data.length > 0) {
                let ymsSpuList = data.map((item) => {
                  return item.newYmsSpu;
                });
                v.ymsSpuList = v.uniqueFunc(ymsSpuList);
                v.designSuccessPromptModal = true;
                v.designSuccessPromptTitle = v.operationType === 'customDesign' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000706') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000707');
              }
              v.customizeMyDesignModal = false;
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
            }
          });
        }
      }
    },
    // 保存定制部位的数据
    saveCustomizedPartsData() {
      let v = this;
      return new Promise((resolve) => {
        const fieldList = [
          {key: 'customizedParts', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000692')},
          {key: 'materialImageList', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000693')},
          {key: 'finishedProductPreviewImageList', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000694')}
        ];
        for (let i = 0; i < v.customizedContentTableData.length; i++) {
          const item = v.customizedContentTableData[i];
          for (const field of fieldList) {
            const value = item[field.key];
            if ((field.key !== 'customizedParts' && (!value || value.length === 0)) || (field.key === 'customizedParts' && !value)) {
              v.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000679')}${i + 1}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000680')}${field.name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000681')}`);
              return;
            }
          }
        }
        let list = [];
        if (v.customizedContentTableData.length > 0) {
          let partBos = [];
          const handleImgList = (imgData, type) => {
            let newList = imgData.map((k) => {
              return {
                path: v.setImgPath(k, 'distributor', null, null, false),
                imageType: type
              };
            });
            return newList;
          };
          v.customizedContentTableData.map((item) => {
            let parts = v.customizedPartsList.filter(ele => ele.ymsProductCategoryPositionId === item.customizedParts)[0].parts;
            let finishedProductPreviewImageList = item.finishedProductPreviewImageList || [];
            let materialImageList = item.materialImageList || [];
            partBos.push({
              parts,
              imageBos: [
                ...handleImgList(materialImageList, 1),
                ...handleImgList(finishedProductPreviewImageList, 2)
              ]
            });
          });
          // 批量配置
          if (v.batchConfigTalg) {
            v.selectGoodsList.map((item) => {
              list.push({
                partBos,
                ymsProductGoodsId: item.ymsProductGoodsId,
                ymsSku: item.ymsSku,
              });
            });
          }
          // 单个配置
          else {
            list = [{
              partBos,
              ymsProductGoodsId: v.detailsData.ymsProductGoodsId,
              ymsSku: v.detailsData.ymsSku
            }];
          }
          if (list.length > 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
            const listMap = new Map(list.map(item => [item.ymsProductGoodsId, item]));
            const dataCollections = [v.specificationsTableData, v.cacheData, v.originalSpecificationsTableData];
            dataCollections.forEach(collection => {
              collection.forEach(item => {
                const matchedItem = listMap.get(item.ymsProductGoodsId);
                if (matchedItem) {
                  item.configureCustomizedInfo = matchedItem;
                }
              });
            });
            setTimeout(() => {
              v.customizedInfoConfigTalg = false;
              v.customizedContentTableData = [];
              v.customizedPartsList = [];
              v.selectGoodsList = [];
              v.batchConfigTalg = false;
              v.detailsData = {};
              v.progressStatus = 1;
              v.theSameTalg = false;
            }, 500);
            resolve(list);
          }
        }
      });
    },
    // 添加定制部位
    addCustomizedContentBtn() {
      this.customizedContentTableData.push({
        customizedParts: null,
        materialImageList: [],
        finishedProductPreviewImageList: []
      });
    },
    // 删除定制部位
    deleteCustomizedContentBtn(index) {
      this.customizedContentTableData.splice(index, 1);
      this.customizedPartsList.forEach(item => {
        item.disabled = false;
        this.customizedContentTableData.map((ele) => {
          if (item.ymsProductCategoryPositionId === ele.customizedParts) {
            item.disabled = true;
          }
        });
      });
      this.$forceUpdate();
    },
    // 批量配置
    batchConfigurationBtn() {
      if (this.selectGoodsList.length > 0) {
        this.configureCustomizedContentData('all');
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000709'));
        return false;
      }
    },
    // 处理配置定制内容
    configureCustomizedContentData(type, obj, index) {
      this.currentIndex = index;
      this.customizedInfoConfigTalg = true;
      this.batchConfigTalg = type === 'all';
      if (type === 'single') {
        let {ymsProductGoodsPositions, configureCustomizedInfo} = obj;
        this.customizedPartsList = JSON.parse(JSON.stringify(ymsProductGoodsPositions));
        this.selectGoodsList = [obj];
        this.detailsData = JSON.parse(JSON.stringify(obj));
        // 已配置定制内容
        let newList = [];
        if (Object.keys(configureCustomizedInfo).length > 0) {
          let partBosList = configureCustomizedInfo.partBos;
          partBosList.map((item) => {
            let materialImageList = item.imageBos.filter(ele => ele.imageType === 1);
            let finishedProductPreviewImageList = item.imageBos.filter(ele => ele.imageType === 2);
            newList.push({
              customizedParts: ymsProductGoodsPositions.filter((ele) => ele.parts === item.parts)[0].ymsProductCategoryPositionId,
              materialImageList: materialImageList.map(ele => ele.path),
              finishedProductPreviewImageList: finishedProductPreviewImageList.map(ele => ele.path)
            });
          });
          this.customizedContentTableData = newList;
          this.customizedPartsList.forEach(item => {
            item.disabled = false;
            this.customizedContentTableData.map((ele) => {
              if (item.ymsProductCategoryPositionId === ele.customizedParts) {
                item.disabled = true;
              }
            });
          });
        }
        // 未配置定制内容
        else {
          this.addCustomizedContentBtn();
        }
      }
      // 批量配置定制内容
      else {
        const newList = [];
        if (this.selectGoodsList.length > 1) {
          const idCount = this.selectGoodsList.reduce((acc, item) => {
            (item.ymsProductGoodsPositions || []).forEach(pos => {
              acc[pos.ymsProductCategoryPositionId] = (acc[pos.ymsProductCategoryPositionId] || 0) + 1;
            });
            return acc;
          }, {});
          const duplicatedIds = new Set(Object.keys(idCount).filter(id => idCount[id] > 1));
          const added = new Set();
          this.selectGoodsList.forEach(item => {
            (item.ymsProductGoodsPositions || []).forEach(pos => {
              if (duplicatedIds.has(pos.ymsProductCategoryPositionId)) {
                const key = `${pos.ymsProductCategoryPositionId}_${pos.parts}`;
                if (!added.has(key)) {
                  newList.push({...pos});
                  added.add(key);
                }
              }
            });
          });
          newList.forEach(item => {
            item.disabled = false;
          });
        } else {
          this.selectGoodsList.forEach(item => {
            (item.ymsProductGoodsPositions || []).forEach(pos => {
              newList.push({...pos, disabled: false});
            });
          });
        }
        this.customizedPartsList = this.uniqueFunc(newList, 'ymsProductCategoryPositionId');
        this.addCustomizedContentBtn();
      }
    },
    // 选择定制部位
    customizedPartsChange(value) {
      this.customizedPartsList.forEach(item => {
        item.disabled = false;
        this.customizedContentTableData.map((ele) => {
          if (item.ymsProductCategoryPositionId === ele.customizedParts) {
            item.disabled = true;
          }
        });
      });
    },
    // 上传图片之前的校验
    handleImgbeforeUpload(file, type) {
      const maxSize = 5;
      return new Promise((resolve, reject) => {
        const isJPG = ['image/png', 'image/jpeg', 'image/jpg'].includes(file.type);
        const isLtMax = file.size / 1024 / 1024 <= maxSize;

        if (!isJPG) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000710'));
          reject();
        }
        if (!isLtMax) {
          this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000711'));
          reject();
        }
        resolve();
      });
    },
    // 上传图片成功
    uploadImageSuccess(response, file, fileList, index, type) {
      let name = type === 'materialImage' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000693') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000694');
      if (response.code === 0 && response.datas) {
        let url = response.datas[0];
        if (url) {
          this.customizedContentTableData[index][type + 'List'].push(url);
          let length = 2;
          if (type === 'materialImage') {
            length = 1;
          }
          this.customizedContentTableData[index][type + 'List'] = this.customizedContentTableData[index][type + 'List'].slice(0, length);
        }
        this.$Message.success(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000683')}`);
      } else {
        this.$Message.error(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000682')}${name}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000684')}`);
      }
    },
    // 删除图片
    deleteImgBtn(index, imageIndex, type) {
      this.customizedContentTableData[index][type + 'List'].splice(imageIndex, 1);
      this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000712'));
      this.$forceUpdate();
    },
    // 跳转到我设计的商品列表
    designSuccessPromptBtn(type) {
      if (type === 'toBack') {
        commonLocalStorage.setItem('customizedProductsYmsSpuList', this.ymsSpuList);
        pageJump('/distributor.html#/designedProductsList', '/yms-distributor-service', '_blank');
      } else {
        this.$emit('updateTableData', this.ymsSpuList);
      }
      this.designSuccessPromptModal = false;
    },
    // 获取所有支持定制商品数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.tableLoading = true;
      let obj = Object.assign({}, v.pageParams);
      let query = {
        ymsProductCategoryId: obj.ymsProductCategoryId,
        cnName: obj.cnName,
        ymsSpus: obj.ymsSpus ? [obj.ymsSpus] : [],
        /* distributorMerchantId: v.userInfo.merchantId,*/
        shelveStatus: 1,
        orderBy: 'createdTime',
        upDown: 'down',
        isSupportCustomization: 1,
        /* productTypes: ['1', '2', '3', '4', '5'],*/
        pageNum: obj.pageNum,
        pageSize: obj.pageSize
      };
      v.axios.post(api.post_ymsProductInfo_api_query, query).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let list = data.list || [];
          list.forEach(item => {
            item.selectCustomizedProducts = 0;
          });
          v.tableData = list;
          v.total = data.total;
          v.updateTableDom('tbableDom');
        } else {
          v.tableLoading = false;
        }
      });
    },
    // 选择定制商品
    selectCustomizedProductsChange(val, row, index) {
      let v = this;
      v.tableData.map((item) => {
        item.selectCustomizedProducts = 0;
      });
      setTimeout(() => {
        v.$set(v.tableData[index], 'selectCustomizedProducts', 1);
        v.productGoodsList = row.productGoodsList || [];
      }, 20);
      v.$forceUpdate();
    },
    // 监听弹窗
    customizeMyDesignChange(value) {
      if (!value) {
        this.resetData();
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    vueTreeSelect
  }
};
</script>

<style lang="less" scoped>
.customizeMyDesignDrawer_box {
  /deep/ .ivu-drawer-body {
    padding: 0 20px;

    .stepBar_box {
      padding: 10px 100px;
      background-color: #fff;

      .ivu-steps {
        .ivu-steps-item {
          overflow: initial;
        }

        .ivu-steps-main {
          display: flex;
          flex-direction: column;
        }

        .ivu-steps-head {
          display: table-cell;
          padding-left: 0;
        }

        .ivu-steps-tail {
          left: 7px;
        }

        .ivu-steps-content {
          padding: 0;
        }
      }
    }

    .ivu-card-head {
      padding: 14px 0;
    }

    .ivu-card-body {
      padding: 14px 0;
    }

    .title_box {
      color: #333;
      font-size: 15px;
      font-weight: bold;
      background-color: #fff;
    }

    .red-dot:before {
      content: '*';
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      font-family: SimSun;
      font-size: 14px;
      color: #ed4014;
    }

    .specificationsName {
      display: inline-block;
      line-height: 22px;
      height: 22px;
    }

    .ivu-tag {
      border-radius: 11px;
      cursor: pointer;
      margin: 0 12px 0 0;
      padding: 0 10px;
    }

    .setCursor {
      cursor: not-allowed;
    }

    .imgagesList_box {
      margin: 8px 0;
      display: flex;
      flex-wrap: wrap;
      position: relative;

      .imgagesList_box_item {
        margin: 0 8px 0 0;

        .img_content {
          position: relative;
          cursor: pointer;
          width: 75px;
          height: 75px;

          .clickOnCrop_box {
            width: 100%;
            height: 20px;
            line-height: 20px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            text-align: center;
            font-size: 12px;
            color: #fff;
            background-color: #ada9a9;
            display: none;
          }

          &:hover {
            .clickOnCrop_box {
              display: inline-block;
            }
          }
        }

        .img-styles {
          width: 75px;
          height: 75px;
          object-fit: cover;
          border: 1px solid #ddd;
        }
      }

      .upload-box {
        width: 75px;
        height: 75px;
        color: #999999;
        transition: color 0.1s ease-in;
        background: #fff;
        border: 1px dashed #dcdee2;
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .upload-icon {
          font-size: 30px;
          display: block;
        }

        &:hover {
          color: #666666;
        }
      }

      .select_customized {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }

  .drawer_footer {
    width: 1000px;
    position: fixed;
    bottom: 0;
    right: 0;
    border-top: 1px solid #e8eaec;
    text-align: left;
    padding: 12px 0 12px 15px;
    background-color: #fff;
    z-index: 100;
  }
}
</style>
